'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Board,
    BoardGUI,
    Const,
    GameGUI,
    Piece,
    Player,
    State,
    crypto,
    indexOf = [].indexOf;

crypto = require('crypto');

Const = require('./const');

Piece = require('./piece');

Board = require('./board');

Player = require('./player');

$(function () {
  return new GameGUI();
});

Array.prototype.unique = function () {
  var key, l, output, ref, results, value;
  output = {};
  for (key = l = 0, ref = this.length; 0 <= ref ? l < ref : l > ref; key = 0 <= ref ? ++l : --l) {
    output[this[key]] = this[key];
  }
  results = [];
  for (key in output) {
    value = output[key];
    results.push(value);
  }
  return results;
};

BoardGUI = function () {
  var getImg;

  var BoardGUI = function (_Board) {
    _inherits(BoardGUI, _Board);

    function BoardGUI() {
      _classCallCheck(this, BoardGUI);

      var _this = _possibleConstructorReturn(this, (BoardGUI.__proto__ || Object.getPrototypeOf(BoardGUI)).call(this));

      _this.width = 0;
      _this.height = 0;
      _this.statusarea = null;
      return _this;
    }

    _createClass(BoardGUI, [{
      key: 'display',
      value: function display() {
        var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var col, f_motigoma, html, i, ids, k, koma, l, len, len1, m, n, p, ref, ref1, ref2, ref3, row, s_motigoma, v;
        // console.log("BoardGUI.display")
        ids = id === null ? "" : "_" + id.toString();
        s_motigoma = {
          "Hi": 0,
          "Ka": 0,
          "Ki": 0,
          "Gi": 0,
          "Ke": 0,
          "Ky": 0,
          "Fu": 0
        };
        ref = this.pieces;
        for (i = l = 0, len = ref.length; l < len; i = ++l) {
          v = ref[i];
          if (v.turn === Const.SECOND && v.status === Const.Status.MOTIGOMA) {
            s_motigoma[v.kind()] += 1;
          }
        }
        if (id === null) {
          for (k in s_motigoma) {
            v = s_motigoma[k];
            $('#s' + k + ids).text(v.toString());
          }
        } else {
          html = '<div id="btnSecond" class="ui-btn ui-no-icon ui-alt-icon ui-mini ui-nodisc-icon ui-btn-icon-right ui-btn-inline"><b>' + i18next.t('menu_second') + '</b></div>';
          $('#group_s' + ids).append(html);
          for (k in s_motigoma) {
            v = s_motigoma[k];
            if (v > 0) {
              html = '<div class="ui-btn ui-icon-s' + k.toLowerCase() + ' ui-mini ui-nodisc-icon ui-btn-icon-left ui-btn-inline">' + v + '</div>';
              $('#group_s' + ids).append(html);
            }
          }
        }
        for (row = m = 1, ref1 = this.rows; 1 <= ref1 ? m <= ref1 : m >= ref1; row = 1 <= ref1 ? ++m : --m) {
          for (col = n = ref2 = this.cols; n >= 1; col = n += -1) {
            $('#b' + row.toString() + col.toString()).css('background-color', '#FFFACD');
            $('#b' + row.toString() + col.toString()).css('border-style', 'solid');
            koma = function () {
              var len1, p, ref3, results;
              ref3 = this.pieces;
              results = [];
              for (p = 0, len1 = ref3.length; p < len1; p++) {
                v = ref3[p];
                if (v.posi != null && v.posi.toString() === [col, row].toString()) {
                  results.push(v);
                }
              }
              return results;
            }.call(this)[0];
            if (koma != null) {
              $('#b' + koma.posi[0] + koma.posi[1] + ids).children('img').attr({
                'src': getImg.call(this, koma),
                'alt': koma.caption(),
                'class': koma.turn === Const.FIRST ? 'first' : 'second'
              });
            } else {
              $('#b' + col + row + ids).children('img').attr({
                'src': './img/empty.svg',
                'class': 'empty'
              });
            }
          }
        }
        f_motigoma = {
          "Hi": 0,
          "Ka": 0,
          "Ki": 0,
          "Gi": 0,
          "Ke": 0,
          "Ky": 0,
          "Fu": 0
        };
        ref3 = this.pieces;
        for (i = p = 0, len1 = ref3.length; p < len1; i = ++p) {
          v = ref3[i];
          if (v.turn === Const.FIRST && v.status === Const.Status.MOTIGOMA) {
            f_motigoma[v.kind()] += 1;
          }
        }
        if (id === null) {
          for (k in f_motigoma) {
            v = f_motigoma[k];
            $('#f' + k + ids).text(v.toString());
          }
        } else {
          html = '<div id="btnFirst" class="ui-btn ui-no-icon ui-alt-icon ui-mini ui-nodisc-icon ui-btn-icon-right ui-btn-inline"><b>' + i18next.t('menu_first') + '</b></div>';
          $('#group_f' + ids).append(html);
          for (k in f_motigoma) {
            v = f_motigoma[k];
            if (v > 0) {
              html = '<div class="ui-btn ui-icon-f' + k.toLowerCase() + ' ui-mini ui-nodisc-icon ui-btn-icon-left ui-btn-inline">' + v + '</div>';
              $('#group_f' + ids).append(html);
            }
          }
        }
      }
    }, {
      key: 'init',
      value: function init() {
        return this.statusarea = document.getElementById("spanStatus");
      }
    }]);

    return BoardGUI;
  }(Board);

  ;

  getImg = function getImg(piece) {
    var ret;
    ret = "";
    switch (piece.kind()) {
      case "Ou":
        ret = piece.turn === Const.FIRST ? "./img/f_ou.svg" : "./img/s_ou.svg";
        break;
      case "Hi":
        if (piece.status === Const.Status.URA) {
          ret = piece.turn === Const.FIRST ? "./img/f_ry.svg" : "./img/s_ry.svg";
        } else {
          ret = piece.turn === Const.FIRST ? "./img/f_hi.svg" : "./img/s_hi.svg";
        }
        break;
      case "Ka":
        if (piece.status === Const.Status.URA) {
          ret = piece.turn === Const.FIRST ? "./img/f_um.svg" : "./img/s_um.svg";
        } else {
          ret = piece.turn === Const.FIRST ? "./img/f_ka.svg" : "./img/s_ka.svg";
        }
        break;
      case "Ki":
        ret = piece.turn === Const.FIRST ? "./img/f_ki.svg" : "./img/s_ki.svg";
        break;
      case "Gi":
        if (piece.status === Const.Status.URA) {
          ret = piece.turn === Const.FIRST ? "./img/f_ng.svg" : "./img/s_ng.svg";
        } else {
          ret = piece.turn === Const.FIRST ? "./img/f_gi.svg" : "./img/s_gi.svg";
        }
        break;
      case "Ke":
        if (piece.status === Const.Status.URA) {
          ret = piece.turn === Const.FIRST ? "./img/f_nk.svg" : "./img/s_nk.svg";
        } else {
          ret = piece.turn === Const.FIRST ? "./img/f_ke.svg" : "./img/s_ke.svg";
        }
        break;
      case "Ky":
        if (piece.status === Const.Status.URA) {
          ret = piece.turn === Const.FIRST ? "./img/f_ny.svg" : "./img/s_ny.svg";
        } else {
          ret = piece.turn === Const.FIRST ? "./img/f_ky.svg" : "./img/s_ky.svg";
        }
        break;
      case "Fu":
        if (piece.status === Const.Status.URA) {
          ret = piece.turn === Const.FIRST ? "./img/f_to.svg" : "./img/s_to.svg";
        } else {
          ret = piece.turn === Const.FIRST ? "./img/f_fu.svg" : "./img/s_fu.svg";
        }
    }
    return ret;
  };

  return BoardGUI;
}.call(undefined);

State = function State(turn1, status) {
  var posi1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  _classCallCheck(this, State);

  this.turn = turn1;
  this.status = status;
  this.posi = posi1;
};

GameGUI = function () {
  var is_oute;

  var GameGUI = function () {
    function GameGUI() {
      _classCallCheck(this, GameGUI);

      var special_event;
      // console.log("GameGUI.constructor")
      this.selected = null;
      this.posi = null;
      this.s_posi = null;
      this.d_posi = null;
      this.pre_posi = null;
      this.interrupt_flg = false;
      this.auto_flg = false;
      this.history = [];
      this.duplication = [];
      this.first_player = null;
      this.second_player = null;
      this.first = new Player(Const.FIRST, true);
      this.second = new Player(Const.SECOND, true);
      this.teban = this.first;
      this.board = new BoardGUI();
      this.md5hash = null;
      special_event = typeof cordova === "undefined" ? "DOMContentLoaded" : "deviceready";
      this.setEventListener(special_event);
    }

    _createClass(GameGUI, [{
      key: 'viewState',
      value: function viewState() {
        var i, l, len, ref, v;
        ref = this.board.pieces;
        for (i = l = 0, len = ref.length; l < len; i = ++l) {
          v = ref[i];
          v.turn = this.history[this.seq]["board"][i].turn;
          v.status = this.history[this.seq]["board"][i].status;
          v.posi = this.history[this.seq]["board"][i].posi;
        }
        $('#naviSeq').text(this.seq.toString());
        this.board.display();
        return $('#b' + this.history[this.seq]["latest"][0] + this.history[this.seq]["latest"][1]).css('border-style', 'dashed');
      }
    }, {
      key: 'addState',
      value: function addState() {
        var md5hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var latest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var l, len, record, ref, v;
        // console.log("GameGUI.addState")
        record = {};
        record["latest"] = [].concat(latest);
        record["board"] = [];
        ref = this.board.pieces;
        for (l = 0, len = ref.length; l < len; l++) {
          v = ref[l];
          record["board"].push(new State(v.turn, v.status, [].concat(v.posi)));
        }
        this.history.push(record);
        this.duplication.push(md5hash);
        return $('#naviSeq').text((this.history.length - 1).toString());
      }

      // ゲーム開始毎

    }, {
      key: 'prepare',
      value: function prepare() {
        var err;
        // console.log("GameGUI.prepare")
        this.interrupt_flg = false;
        this.auto_flg = false;
        this.history = [];
        this.duplication = [];
        this.seq = 0;
        $('#naviSeq').text('');
        this.startbtn.disabled = true;
        $("#btnStop").val(i18next.t('msgInterrupt')).button("refresh");
        this.naviA.style.display = "none";
        this.board.statusarea.innerHTML = i18next.t('msgTurn', {
          postProcess: 'sprintf',
          sprintf: [i18next.t('msgBlack')]
        });
        this.teban = this.first;
        // radio_checked = (v for v in @radio_arrange when v.checked == true)[0]
        // launch.call @, parseInt(radio_checked.value|0, 10)
        this.set_standard();
        this.addState();
        this.board.display();
        try {
          this.first_player.selectedIndex = parseInt(localStorage.getItem("first_player99") | 0, 10);
          this.second_player.selectedIndex = parseInt(localStorage.getItem("second_player99") | 0, 10);
        } catch (error) {
          err = error;
          this.first_player.selectedIndex = 0;
          this.second_player.selectedIndex = 0;
        }
        this.first.human = first_player.selectedIndex === 1 ? false : true;
        return this.second.human = second_player.selectedIndex === 1 ? false : true;
      }
    }, {
      key: 'auto_battle',
      value: function auto_battle(seq) {
        var _this2 = this;

        var chk_sennitite, i, l, len, oppo, player, ref, ret, src_posi, temp, threshold;
        this.seq = seq;
        // console.log("auto_battle")
        this.auto_flg = true;
        if (this.teban.turn === Const.FIRST) {
          player = this.first;
          oppo = this.second;
          threshold = Const.MAX_VALUE;
        } else {
          player = this.second;
          oppo = this.first;
          threshold = Const.MIN_VALUE;
        }
        temp = [];
        ret = [];
        ref = [1, player.depth].unique();
        for (l = 0, len = ref.length; l < len; l++) {
          i = ref[l];
          temp = [];
          temp = player.think(this.board, oppo, i, threshold);
          if (temp[0] != null) {
            // console.log("turn = #{player.turn}: i = #{i}, kind = #{temp[0].kind()}, temp = #{JSON.stringify(temp)}")
            ret = [].concat(temp);
            if (temp[2] >= Const.MAX_VALUE || temp[2] <= Const.MIN_VALUE) {
              break;
            }
          } else {
            // console.log("turn = #{player.turn}: i = #{i}, kind = #{temp[0]}, temp = #{JSON.stringify(temp)}")
            break;
          }
        }
        if (ret[0]) {
          // 一手前のハッシュ値ですでに千日手判定されていればreturn
          chk_sennitite = this.sennitite(this.md5hash);
          if (chk_sennitite) {
            this.board.display();
            $('#b' + ret[1][0] + ret[1][1]).css('border-style', 'dashed');
            this.auto_flg = false;
            return;
          } else if (chk_sennitite === null && ret[4]["koma"] != null) {
            ret[0] = ret[4]["koma"];
            ret[1] = ret[4]["posi"];
            ret[2] = ret[4]["score"];
            ret[3] = ret[4]["status"];
          }
          if (this.board.check_move(ret[0], ret[1])) {
            src_posi = this.board.move_capture(ret[0], ret[1]);
            ret[0].status = ret[3];
          }
          this.md5hash = crypto.createHash('md5').update(JSON.stringify(this.board.pieces)).digest("hex");
          this.seq += 1;
          this.addState(this.md5hash);
          if (this.sennitite(this.md5hash)) {
            this.board.display();
            $('#b' + ret[1][0] + ret[1][1]).css('border-style', 'dashed');
            this.auto_flg = false;
            return;
          }
          this.teban = this.seq % 2 === 0 ? this.first : this.second;
          if (this.teban.turn === Const.FIRST) {
            this.board.statusarea.innerHTML = i18next.t('msgTurn', {
              postProcess: 'sprintf',
              sprintf: [i18next.t('msgBlack')]
            });
          } else {
            this.board.statusarea.innerHTML = i18next.t('msgTurn', {
              postProcess: 'sprintf',
              sprintf: [i18next.t('msgWhite')]
            });
          }
          this.board.statusarea.innerHTML = this.board.statusarea.innerHTML + i18next.t('msgEvaluate', {
            postProcess: 'sprintf',
            sprintf: [ret[2].toString()]
          });
        } else {
          if (this.teban.turn === Const.FIRST) {
            this.board.statusarea.innerHTML = i18next.t('msgWinner', {
              postProcess: 'sprintf',
              sprintf: [i18next.t('msgWhite')]
            });
          } else {
            this.board.statusarea.innerHTML = i18next.t('msgWinner', {
              postProcess: 'sprintf',
              sprintf: [i18next.t('msgBlack')]
            });
          }
          this.startbtn.disabled = false;
          $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
          this.naviA.style.display = "block";
          this.auto_flg = false;
          return;
        }
        this.board.display();
        $('#b' + ret[1][0] + ret[1][1]).css('border-style', 'dashed');
        if (this.interrupt_flg) {
          this.interrupt_flg = false;
          this.auto_flg = false;
          this.board.statusarea.innerHTML = "";
          return;
        } else {
          setTimeout(function () {
            return _this2.auto_battle(_this2.seq);
          }, 1000);
        }
      }

      // 起動時

    }, {
      key: 'init',
      value: function init() {
        var _this3 = this;

        var depth_f, depth_s, err, i, j, l, m;
        // console.log("GameGUI.init")
        this.startbtn = document.getElementById("btnStart");
        this.first_player = document.getElementById("first_player");
        this.second_player = document.getElementById("second_player");
        this.radio_depth_f = document.getElementsByName("f-radio-depth");
        this.radio_depth_s = document.getElementsByName("s-radio-depth");
        this.naviA = document.getElementById("naviA");
        this.naviA.style.display = "none";
        try {
          this.first_player.selectedIndex = parseInt(localStorage.getItem("first_player99") | 0, 10);
          this.second_player.selectedIndex = parseInt(localStorage.getItem("second_player99") | 0, 10);
          depth_f = parseInt(localStorage.getItem("f-radio-depth99") | 0, 10);
          depth_s = parseInt(localStorage.getItem("s-radio-depth99") | 0, 10);
          if (depth_f === 1) {
            this.radio_depth_f[1].checked = true;
            this.first.depth = 2;
            this.first.pre_select = 12;
          } else {
            this.radio_depth_f[0].checked = true;
            this.first.depth = 1;
            this.first.pre_select = 12;
          }
          if (depth_s === 1) {
            this.radio_depth_s[1].checked = true;
            this.second.depth = 2;
            this.second.pre_select = 12;
          } else {
            this.radio_depth_s[0].checked = true;
            this.second.depth = 1;
            this.second.pre_select = 12;
          }
          $("#level-first input[type='radio']").checkboxradio();
          $("#level-first input[type='radio']").checkboxradio('refresh');
          $("#level-second input[type='radio']").checkboxradio();
          $("#level-second input[type='radio']").checkboxradio('refresh');
          if (this.first_player.selectedIndex === 0) {
            $("#level-first input[type='radio']").checkboxradio('disable');
          } else {
            $("#level-first input[type='radio']").checkboxradio('enable');
          }
          if (this.second_player.selectedIndex === 0) {
            $("#level-second input[type='radio']").checkboxradio('disable');
          } else {
            $("#level-second input[type='radio']").checkboxradio('enable');
          }
        } catch (error) {
          err = error;
          console.log("=== Error ===");
          console.log(err);
          this.first_player.selectedIndex = 0;
          this.second_player.selectedIndex = 0;
          this.first.depth = 1;
          this.first.pre_select = 12;
          this.second.depth = 1;
          this.second.pre_select = 12;
          this.radio_depth_f[0].checked = true;
          this.radio_depth_s[0].checked = true;
        }
        $('#btnStart').on('click', function (e) {
          var target;
          target = $(e.currentTarget);
          _this3.prepare();
          _this3.first.human = _this3.first_player.selectedIndex === 1 ? false : true;
          _this3.second.human = _this3.second_player.selectedIndex === 1 ? false : true;
          if (!_this3.first.human && !_this3.second.human) {
            _this3.board.statusarea.innerHTML = i18next.t('msgThinking');
            _this3.board.display();
            setTimeout(function () {
              return _this3.auto_battle(_this3.seq);
            }, 1000);
          } else if (!_this3.first.human) {
            _this3.board.statusarea.innerHTML = i18next.t('msgThinking');
            setTimeout(function () {
              var event;
              event = new $.Event('ai_thinking');
              return $(window).trigger(event);
            }, 500);
          }
        });
        $('#naviStart').on('click', function (e) {
          _this3.seq = 0;
          _this3.viewState();
        });
        $('#naviPrev').on('click', function (e) {
          if (_this3.seq > 0) {
            _this3.seq -= 1;
          }
          _this3.viewState();
        });
        $('#naviFollow').on('click', function (e) {
          if (_this3.seq < _this3.history.length - 1) {
            _this3.seq += 1;
          }
          _this3.viewState();
        });
        $('#naviEnd').on('click', function (e) {
          _this3.seq = _this3.history.length - 1;
          _this3.viewState();
        });
        for (i = l = 1; l <= 9; i = ++l) {
          for (j = m = 1; m <= 9; j = ++m) {
            $('#b' + i.toString() + j.toString()).on('click', function (e) {
              _this3.select([Number(e.currentTarget.dataset.col), Number(e.currentTarget.dataset.row)]);
            });
          }
        }
        $('#sFu').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#sHi').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#sKa').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#sKi').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#sGi').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#sKe').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#sKy').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#fFu').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#fHi').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#fKa').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#fKi').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#fGi').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#fKe').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#fKy').on('click', function (e) {
          _this3.motigoma(e.currentTarget.id[0] === "s" ? Const.SECOND : Const.FIRST, e.currentTarget.id.slice(1, 3));
        });
        $('#btnInterrupt').on('click', function (e) {
          _this3.interrupted();
          return location.href = "#win_menu";
        });
        $('#btnStop').on('click', function (e) {
          return _this3.interrupted();
        });
        $('#btnNari').on('click', function (e) {
          return _this3.routine(_this3.selected, _this3.posi, true);
        });
        $('#btnNarazu').on('click', function (e) {
          return _this3.routine(_this3.selected, _this3.posi, false);
        });
        $('input[name="f-radio-depth"]').on('change', function (e) {
          var target;
          target = $(e.currentTarget);
          try {
            if (_this3.radio_depth_f[1].checked) {
              localStorage.setItem("f-radio-depth99", 1);
              _this3.first.depth = 2;
              return _this3.first.pre_select = 12;
            } else {
              localStorage.setItem("f-radio-depth99", 0);
              _this3.first.depth = 1;
              return _this3.first.pre_select = 12;
            }
          } catch (error) {
            err = error;
            return console.log(err);
          }
        });
        $('input[name="s-radio-depth"]').on('change', function (e) {
          var target;
          target = $(e.currentTarget);
          try {
            if (_this3.radio_depth_s[1].checked) {
              localStorage.setItem("s-radio-depth99", 1);
              _this3.second.depth = 2;
              return _this3.second.pre_select = 12;
            } else {
              localStorage.setItem("s-radio-depth99", 0);
              _this3.second.depth = 1;
              return _this3.second.pre_select = 12;
            }
          } catch (error) {
            err = error;
            return console.log(err);
          }
        });
        $('#first_player').on('change', function (e) {
          var target;
          target = $(e.currentTarget);
          try {
            if (target.context.selectedIndex === 0) {
              $("#level-first input[type='radio']").checkboxradio('disable');
            } else {
              $("#level-first input[type='radio']").checkboxradio('enable');
            }
            return localStorage.setItem("first_player99", target.context.selectedIndex);
          } catch (error) {
            err = error;
            return console.log(err);
          }
        });
        return $('#second_player').on('change', function (e) {
          var target;
          target = $(e.currentTarget);
          try {
            if (target.context.selectedIndex === 0) {
              $("#level-second input[type='radio']").checkboxradio('disable');
            } else {
              $("#level-second input[type='radio']").checkboxradio('enable');
            }
            return localStorage.setItem("second_player99", target.context.selectedIndex);
          } catch (error) {
            err = error;
            return console.log(err);
          }
        });
      }
    }, {
      key: 'interrupted',
      value: function interrupted() {
        var _this4 = this;

        var err, oppo, ret, threshold;
        // console.log("Game.interrupted")
        if (this.seq == null) {
          return;
        }
        if (this.startbtn.disabled) {
          this.interrupt_flg = true;
          $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
          this.startbtn.disabled = false;
          this.naviA.style.display = "block";
          this.board.statusarea.innerHTML = "";
        } else {
          this.interrupt_flg = false;
          $("#btnStop").val(i18next.t('msgInterrupt')).button("refresh");
          this.startbtn.disabled = true;
          this.naviA.style.display = "none";
          if (this.seq % 2 === 0) {
            this.board.statusarea.innerHTML = i18next.t('msgTurn', {
              postProcess: 'sprintf',
              sprintf: [i18next.t('msgBlack')]
            });
          } else {
            this.board.statusarea.innerHTML = i18next.t('msgTurn', {
              postProcess: 'sprintf',
              sprintf: [i18next.t('msgWhite')]
            });
          }
          this.teban = this.seq % 2 === 0 ? this.first : this.second;
          try {
            this.first_player.selectedIndex = parseInt(localStorage.getItem("first_player99") | 0, 10);
            this.second_player.selectedIndex = parseInt(localStorage.getItem("second_player99") | 0, 10);
          } catch (error) {
            err = error;
            this.first_player.selectedIndex = 0;
            this.second_player.selectedIndex = 0;
          }
          this.first.human = first_player.selectedIndex === 1 ? false : true;
          this.second.human = second_player.selectedIndex === 1 ? false : true;
          this.history.splice(this.seq + 1);
          this.duplication.splice(this.seq + 1);
          if (!this.first.human && !this.second.human) {
            this.board.statusarea.innerHTML = i18next.t('msgThinking');
            setTimeout(function () {
              return _this4.auto_battle(_this4.seq);
            }, 1000);
          } else if (!this.teban.human) {
            this.board.statusarea.innerHTML = i18next.t('msgThinking');
            setTimeout(function () {
              var event;
              event = new $.Event('ai_thinking');
              return $(window).trigger(event);
            }, 500);
          } else {
            ret = [];
            oppo = this.teban.turn === Const.FIRST ? this.second : this.first;
            threshold = this.teban.turn === Const.FIRST ? Const.MAX_VALUE : Const.MIN_VALUE;
            ret = this.teban.think(this.board, oppo, 1, threshold);
            if (!ret[0]) {
              switch (ret[2]) {
                case Const.MAX_VALUE:
                  this.board.statusarea.innerHTML = i18next.t('msgFirstWin');
                  this.startbtn.disabled = false;
                  $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
                  this.naviA.style.display = "block";
                  break;
                case Const.MIN_VALUE:
                  this.board.statusarea.innerHTML = i18next.t('msgSecondWin');
                  this.startbtn.disabled = false;
                  $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
                  this.naviA.style.display = "block";
                  break;
                default:
                  console.log("Error!");
              }
              this.board.display();
            }
          }
        }
      }
    }, {
      key: 'sennitite',
      value: function sennitite(h) {
        var b, v;
        b = function () {
          var l, len, ref, results;
          ref = this.duplication;
          results = [];
          for (l = 0, len = ref.length; l < len; l++) {
            v = ref[l];
            if (v === h) {
              results.push(v);
            }
          }
          return results;
        }.call(this);
        if (b.length === 3) {
          return null;
        } else if (b.length >= 4) {
          this.board.statusarea.innerHTML = i18next.t('msgSennitite');
          this.startbtn.disabled = false;
          $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
          this.naviA.style.display = "block";
          return true;
        } else {
          return false;
        }
      }
    }, {
      key: 'routine',
      value: function routine(piece, posi, nari) {
        var oppo, ret, src_posi, threshold;
        // console.log("routine")
        src_posi = this.board.move_capture(piece, posi);
        if (nari) {
          piece.status = Const.Status.URA;
        }
        this.md5hash = crypto.createHash('md5').update(JSON.stringify(this.board.pieces)).digest("hex");
        this.seq += 1;
        this.addState(this.md5hash, posi);
        if (this.sennitite(this.md5hash)) {
          this.board.display();
          $('#b' + posi[0] + posi[1]).css('border-style', 'dashed');
          return;
        }
        this.teban = this.seq % 2 === 0 ? this.first : this.second;
        threshold = this.teban.turn === Const.FIRST ? Const.MAX_VALUE : Const.MIN_VALUE;
        switch (this.board.gameover()) {
          case Const.FIRST:
            this.board.statusarea.innerHTML = i18next.t('msgFirstWin');
            this.startbtn.disabled = false;
            $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
            this.naviA.style.display = "block";
            this.board.display();
            $('#b' + posi[0] + posi[1]).css('border-style', 'dashed');
            return;
          case Const.SECOND:
            this.board.statusarea.innerHTML = i18next.t('msgSecondWin');
            this.startbtn.disabled = false;
            $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
            this.naviA.style.display = "block";
            this.board.display();
            $('#b' + posi[0] + posi[1]).css('border-style', 'dashed');
            return;
          default:
            if (this.teban.turn === Const.FIRST) {
              this.board.statusarea.innerHTML = i18next.t('msgTurn', {
                postProcess: 'sprintf',
                sprintf: [i18next.t('msgBlack')]
              });
            } else {
              this.board.statusarea.innerHTML = i18next.t('msgTurn', {
                postProcess: 'sprintf',
                sprintf: [i18next.t('msgWhite')]
              });
            }
        }
        this.s_posi = null;
        this.d_posi = null;
        this.board.display();
        $('#b' + posi[0] + posi[1]).css('border-style', 'dashed');
        if (this.teban.human) {
          oppo = this.teban.turn === Const.FIRST ? this.second : this.first;
          ret = [];
          // 詰みチェック
          ret = this.teban.think(this.board, oppo, 1, threshold);
          if (!ret[0]) {
            if (this.teban.turn === Const.FIRST) {
              this.board.statusarea.innerHTML = i18next.t('msgWinner', {
                postProcess: 'sprintf',
                sprintf: [i18next.t('msgWhite')]
              });
            } else {
              this.board.statusarea.innerHTML = i18next.t('msgWinner', {
                postProcess: 'sprintf',
                sprintf: [i18next.t('msgBlack')]
              });
            }
            this.startbtn.disabled = false;
            $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
            this.naviA.style.display = "block";
          }
        } else {
          this.board.statusarea.innerHTML = i18next.t('msgThinking');
          return setTimeout(function () {
            var event;
            event = new $.Event('ai_thinking');
            return $(window).trigger(event);
          }, 500);
        }
      }
    }, {
      key: 'touch',
      value: function touch(piece, posi) {
        var dest, dest_piece, king, move_piece, oppo, player, ref, ret, threshold, v;
        // console.log("touch")
        if (!this.startbtn.disabled) {
          return;
        }
        if (this.auto_flg) {
          return;
        }
        dest = function () {
          var l, len, ref, results;
          ref = this.board.pieces;
          results = [];
          for (l = 0, len = ref.length; l < len; l++) {
            v = ref[l];
            if (v.posi != null && v.posi.toString() === posi.toString()) {
              results.push(v);
            }
          }
          return results;
        }.call(this);
        if (dest.length !== 0 && dest[0].turn === piece.turn) {
          this.s_posi = null;
          return;
        }
        move_piece = new Piece.Piece(piece.turn, piece.status, [].concat(piece.posi));
        if (dest.length !== 0) {
          dest_piece = new Piece.Piece(dest[0].turn, dest[0].status, [].concat(dest[0].posi));
        }
        if (this.board.check_move(piece, posi)) {
          this.board.move_capture(piece, posi);
        } else {
          this.s_posi = null;
          return;
        }
        if (this.teban.turn === Const.FIRST) {
          player = this.second;
          oppo = this.first;
          threshold = Const.MIN_VALUE;
        } else {
          player = this.first;
          oppo = this.second;
          threshold = Const.MAX_VALUE;
        }
        this.board.make_kiki(player.turn);
        king = function () {
          var l, len, ref, results;
          ref = this.board.pieces;
          results = [];
          for (l = 0, len = ref.length; l < len; l++) {
            v = ref[l];
            if (v.kind() === 'Ou' && v.turn === this.teban.turn) {
              results.push(v);
            }
          }
          return results;
        }.call(this)[0];
        if (ref = king.posi.toString(), indexOf.call(this.board.kiki[player.turn].map(function (o) {
          return o.toString();
        }), ref) >= 0) {
          $('#popupCheckLeft').popup("open");
          this.s_posi = null;
          piece.turn = move_piece.turn;
          piece.status = move_piece.status;
          piece.posi = move_piece.posi;
          if (dest.length !== 0) {
            dest[0].turn = dest_piece.turn;
            dest[0].status = dest_piece.status;
            dest[0].posi = dest_piece.posi;
          }
          return;
        }
        if (piece.kind() === 'Fu' && move_piece.status === Const.Status.MOTIGOMA) {
          ret = [];
          ret = player.think(this.board, oppo, 1, threshold);
          if (ret[2] >= Const.MAX_VALUE || ret[2] <= Const.MIN_VALUE) {
            if (is_oute.call(this, piece, posi)) {
              $('#popupDropPawnMate').popup("open");
              this.s_posi = null;
              piece.turn = move_piece.turn;
              piece.status = move_piece.status;
              piece.posi = move_piece.posi;
              return;
            }
          }
        }
        piece.turn = move_piece.turn;
        piece.status = move_piece.status;
        piece.posi = move_piece.posi;
        if (dest.length !== 0) {
          dest[0].turn = dest_piece.turn;
          dest[0].status = dest_piece.status;
          dest[0].posi = dest_piece.posi;
        }
        if (this.board.check_move(piece, posi)) {
          if (this.board.check_promotion(piece, posi)) {
            this.posi = posi;
            $('#popupNari').popup("open");
          } else {
            this.routine(piece, posi, false);
          }
        } else {
          this.s_posi = null;
        }
      }
    }, {
      key: 'motigoma',
      value: function motigoma(turn, kind) {
        var v;
        // console.log("motigoma")
        if (!this.startbtn.disabled) {
          return;
        }
        if (this.pre_posi) {
          $('#b' + this.pre_posi[0] + this.pre_posi[1]).css('background-color', '#FFFACD');
        }
        this.selected = function () {
          var l, len, ref, results;
          ref = this.board.pieces;
          results = [];
          for (l = 0, len = ref.length; l < len; l++) {
            v = ref[l];
            if (v.turn === turn && v.kind() === kind && v.status === Const.Status.MOTIGOMA && v.turn === this.teban.turn) {
              results.push(v);
            }
          }
          return results;
        }.call(this)[0];
        if (this.selected) {
          this.s_posi = !null;
        }
      }
    }, {
      key: 'select',
      value: function select(posi) {
        var v;
        // console.log("select")
        $('#b' + posi[0] + posi[1]).css('background-color', '#FFFACD');
        if (!this.s_posi) {
          this.s_posi = posi;
          this.selected = function () {
            var l, len, ref, results;
            ref = this.board.pieces;
            results = [];
            for (l = 0, len = ref.length; l < len; l++) {
              v = ref[l];
              if (v.posi != null && v.posi.toString() === posi.toString() && v.turn === this.teban.turn) {
                results.push(v);
              }
            }
            return results;
          }.call(this)[0];
          if (this.selected) {
            $('#b' + posi[0] + posi[1]).css('background-color', '#E3D7A6');
            this.pre_posi = posi;
          } else {
            this.s_posi = null;
          }
        } else {
          this.d_posi = posi;
          if (this.pre_posi) {
            $('#b' + this.pre_posi[0] + this.pre_posi[1]).css('background-color', '#FFFACD');
          }
          this.touch(this.selected, this.d_posi);
        }
      }
    }, {
      key: 'set_standard',
      value: function set_standard() {
        this.board.set_standard();
      }
    }, {
      key: 'setBoardSize',
      value: function setBoardSize(w, h) {
        if (w <= h) {
          this.board.width = w * 0.70;
          this.board.height = w * 0.70;
        } else {
          this.board.width = h * 0.70;
          this.board.height = h * 0.70;
        }
      }
    }, {
      key: 'setEventListener',
      value: function setEventListener(special) {
        var _this5 = this;

        $(window).on('ai_thinking', function (e) {
          var chk_sennitite, i, l, len, oppo, oppo_threshold, player, player_threshold, ref, ret, src_posi, temp, tumi;
          // console.log("ai_thinking")
          if (_this5.teban.turn === Const.FIRST) {
            player = _this5.first;
            oppo = _this5.second;
            player_threshold = Const.MAX_VALUE;
            oppo_threshold = Const.MIN_VALUE;
          } else {
            player = _this5.second;
            oppo = _this5.first;
            player_threshold = Const.MIN_VALUE;
            oppo_threshold = Const.MAX_VALUE;
          }
          temp = [];
          ret = [];
          ref = [1, player.depth].unique();
          // 対人戦の場合は相手玉を取るまで指す
          for (l = 0, len = ref.length; l < len; l++) {
            i = ref[l];
            temp = [];
            temp = player.think(_this5.board, oppo, i, player_threshold);
            if (temp[0] != null) {
              ret = [].concat(temp);
              if (temp[2] >= Const.MAX_VALUE || temp[2] <= Const.MIN_VALUE) {
                break;
              }
            } else {
              break;
            }
          }
          if (ret[0]) {
            // 一手前のハッシュ値ですでに千日手判定されていればreturn
            chk_sennitite = _this5.sennitite(_this5.md5hash);
            if (chk_sennitite) {
              _this5.board.display();
              $('#b' + ret[1][0] + ret[1][1]).css('border-style', 'dashed');
              return;
            } else if (chk_sennitite === null && ret[4]["koma"] != null) {
              ret[0] = ret[4]["koma"];
              ret[1] = ret[4]["posi"];
              ret[2] = ret[4]["score"];
              ret[3] = ret[4]["status"];
            }
            if (_this5.board.check_move(ret[0], ret[1])) {
              src_posi = _this5.board.move_capture(ret[0], ret[1]);
              ret[0].status = ret[3];
            }
            _this5.md5hash = crypto.createHash('md5').update(JSON.stringify(_this5.board.pieces)).digest("hex");
            _this5.seq += 1;
            _this5.addState(_this5.md5hash, ret[1]);
            if (_this5.sennitite(_this5.md5hash)) {
              _this5.board.display();
              $('#b' + ret[1][0] + ret[1][1]).css('border-style', 'dashed');
              return;
            }
            _this5.teban = _this5.seq % 2 === 0 ? _this5.first : _this5.second;
          } else {
            if (_this5.teban.turn === Const.FIRST) {
              _this5.board.statusarea.innerHTML = i18next.t('msgWinner', {
                postProcess: 'sprintf',
                sprintf: [i18next.t('msgWhite')]
              });
            } else {
              _this5.board.statusarea.innerHTML = i18next.t('msgWinner', {
                postProcess: 'sprintf',
                sprintf: [i18next.t('msgBlack')]
              });
            }
            _this5.startbtn.disabled = false;
            $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
            _this5.naviA.style.display = "block";
            return;
          }
          // 詰みチェック
          tumi = [];
          tumi = oppo.think(_this5.board, player, 1, oppo_threshold);
          if (!tumi[0]) {
            switch (tumi[2]) {
              case Const.MAX_VALUE:
                _this5.board.statusarea.innerHTML = i18next.t('msgFirstWin');
                _this5.startbtn.disabled = false;
                $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
                _this5.naviA.style.display = "block";
                break;
              case Const.MIN_VALUE:
                _this5.board.statusarea.innerHTML = i18next.t('msgSecondWin');
                _this5.startbtn.disabled = false;
                $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
                _this5.naviA.style.display = "block";
                break;
              default:
                console.log("Error!");
            }
            _this5.board.display();
            return;
          }
          // 相手玉が自爆しても指し手を進めてしまうのでゲーム終了チェック
          switch (_this5.board.gameover()) {
            case Const.FIRST:
              _this5.board.statusarea.innerHTML = i18next.t('msgFirstWin');
              _this5.startbtn.disabled = false;
              $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
              _this5.naviA.style.display = "block";
              break;
            case Const.SECOND:
              _this5.board.statusarea.innerHTML = i18next.t('msgSecondWin');
              _this5.startbtn.disabled = false;
              $("#btnStop").val(i18next.t('msgRestart')).button("refresh");
              _this5.naviA.style.display = "block";
              break;
            default:
              if (_this5.teban.turn === Const.FIRST) {
                _this5.board.statusarea.innerHTML = i18next.t('msgTurn', {
                  postProcess: 'sprintf',
                  sprintf: [i18next.t('msgBlack')]
                });
              } else {
                _this5.board.statusarea.innerHTML = i18next.t('msgTurn', {
                  postProcess: 'sprintf',
                  sprintf: [i18next.t('msgWhite')]
                });
              }
          }
          _this5.board.display();
          return $('#b' + ret[1][0] + ret[1][1]).css('border-style', 'dashed');
        });
        $(document).on('ready', function (e) {
          // console.log("=== Document Ready ===")
          $('#btnStart').val(i18next.t('btn_start')).button('refresh');
          return $('#btnStop').val(i18next.t('btn_stop')).button('refresh');
        });
        $(window).on('load', function (e) {
          var target;
          // console.log("=== Load ===")
          target = $(e.currentTarget);
          _this5.setBoardSize(target.width(), target.height());
          _this5.init();
          return _this5.board.init();
        });
        return $(window).on(special, function (e) {
          var target;
          // console.log("=== Device Ready ===")
          return target = $(e.currentTarget);
        });
      }
    }]);

    return GameGUI;
  }();

  ;

  is_oute = function is_oute(piece, d_posi) {
    var buf, oppo, oppo_king, v;
    oppo = piece.turn === Const.FIRST ? Const.SECOND : Const.FIRST;
    oppo_king = function () {
      var l, len, ref, results;
      ref = this.board.pieces;
      results = [];
      for (l = 0, len = ref.length; l < len; l++) {
        v = ref[l];
        if (v.turn === oppo && v.kind() === 'Ou') {
          results.push(v);
        }
      }
      return results;
    }.call(this)[0];
    buf = [].concat(d_posi);
    buf[0] += eval("Piece." + piece.kind()).getD(piece.turn, piece.status)[0].xd;
    buf[1] += eval("Piece." + piece.kind()).getD(piece.turn, piece.status)[0].yd;
    // check = piece.status == Const.Status.MOTIGOMA && piece.kind() == 'Fu' && oppo_king.posi.toString() == buf.toString()
    return oppo_king.posi.toString() === buf.toString();
  };

  return GameGUI;
}.call(undefined);


//////////////////
// WEBPACK FOOTER
// ./gameGui.coffee
// module id = 129
// module chunks = 0